import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { standardOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { ComponentName, getMetaData } from '../../../Compounds/DetailsDrawer/detailsDrawersHelpers';
import { DetailCTARenderer } from '../../../Compounds/UpstackDataGrid/CellRenderers';

export const DefaultSupplierMapGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.SUPPLIER_MAP, id: params.row.id })
        }}
      />
    ),
    hideable: false,
    disableReorder: true
  },
  {
    headerName: 'Salesforce Supplier',
    field: 'salesforce_supplier_name',
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: standardOperators(),
    renderCell: (params: GridCellParams) => (
      <a
        className="text-indigo"
        title="Open in Salesforce"
        href={`${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${params.row.supplier_sfid}/view`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.salesforce_supplier_name}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'RPM Supplier',
    field: 'rpm_supplier_name',
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: standardOperators(),
    renderCell: (params: GridCellParams) => (
      <a
        className="text-indigo"
        title="Open"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Supplier.aspx?Item=${params.row.rpm_supplier_id}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.rpm_supplier_name}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'note',
    headerName: 'Note',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'supplier_sfid',
    headerName: 'Salesforce ID',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'rpm_supplier_id',
    headerName: 'RPM ID',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  }
];
